var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckblue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82 41C82 63.6437 63.6437 82 41 82C18.3563 82 0 63.6437 0 41C0 18.3563 18.3563 0 41 0C63.6437 0 82 18.3563 82 41Z",
    fill: "#27A0DB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2592 41.036C21.4731 40.9457 21.6092 40.7597 21.7711 40.6088C23.4582 39.0398 25.147 37.4708 26.8182 35.8867C27.0497 35.6679 27.161 35.6831 27.3709 35.9066C30.1295 38.8524 32.8926 41.7945 35.6602 44.7328C35.7507 44.8295 35.8308 44.9357 35.9206 45.0434L43.8196 37.7407C48.0528 33.824 52.2857 29.9056 56.5183 25.9857C56.7779 25.7462 56.8908 25.7605 57.1231 26.0153C58.7566 27.8062 60.4078 29.5804 62.0557 31.3586C62.1203 31.4217 62.1882 31.4814 62.2592 31.5374V31.6173C61.1889 32.593 60.1129 33.5623 59.049 34.5452C51.292 41.7096 43.5385 48.8779 35.7884 56.0503C35.5368 56.2826 35.4439 56.1812 35.2716 55.9984C30.7159 51.1448 26.1575 46.2936 21.5964 41.4448C21.4883 41.3306 21.3713 41.2252 21.2592 41.115V41.036Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckblue);
export default __webpack_public_path__ + "static/media/checkblue.ba161abf45046c797a618f4937ee2036.svg";
export { ForwardRef as ReactComponent };